export enum ModuleTemplate {
	MOOD_SELECTOR = 'MOOD_SELECTOR',
	TITLES_HIDDEN_GEM = 'TITLES_HIDDEN_GEM',
	STANDARD_MODULES_ALIAS = 'STANDARD_MODULES_ALIAS',
}

export enum SPOTLIGHT_MODULE_TECHNICAL_NAME {
	SPOTLIGHT_TRENDING_TODAY = 'SPOTLIGHT_TRENDING_TODAY',
	SPOTLIGHT_CONTINUE_WATCHING = 'SPOTLIGHT_CONTINUE_WATCHING',
	SPOTLIGHT_NEW_ON_YOUR_WATCHLIST = 'SPOTLIGHT_NEW_ON_YOUR_WATCHLIST',
	SPOTLIGHT_NEW_SIMILAR_TO_LIKED_TITLE = 'SPOTLIGHT_NEW_SIMILAR_TO_LIKED_TITLE',
	SPOTLIGHT_NEW_WITH_HIGH_RATINGS = 'SPOTLIGHT_NEW_WITH_HIGH_RATINGS',
	SPOTLIGHT_GOING_VIRAL = 'SPOTLIGHT_GOING_VIRAL',
	UPCOMING_SPORT_EVENTS = 'UPCOMING_SPORT_EVENTS',
}

export enum MAIN_MODULE_TECHNICAL_NAME {
	MAIN_TOP_3_PER_PACKAGE_TODAY = 'MAIN_TOP_3_PER_PACKAGE_TODAY',
	MAIN_TOP_10_IN_YOUR_COUNTRY = 'MAIN_TOP_10_IN_YOUR_COUNTRY',
	MAIN_NEW_PER_PACKAGE_TODAY = 'MAIN_NEW_PER_PACKAGE_TODAY',
	MAIN_WATCHED_BY_SIMILAR_USERS = 'MAIN_WATCHED_BY_SIMILAR_USERS',
	MAIN_BECAUSE_YOU_LIKED_TITLE = 'MAIN_BECAUSE_YOU_LIKED_TITLE',
	MAIN_PERMANENT_AUDIENCE = 'MAIN_PERMANENT_AUDIENCE',
	MAIN_TOP_GENRE = 'MAIN_TOP_GENRE',
	ROTATOR_SQTV = 'ROTATOR_SQTV',
}

export enum TITLE_DETAIL_MODULE_TECHNICAL_NAME {
	QUALITY_TV = 'QUALITY_TV',
	SINGLE_QUALTIY_TV = 'SINGLE_QUALITY_TV',
}

export enum ROTATOR_MODULE_TECHNICAL_NAME {
	FEATURE_ROTATOR = 'FEATURE_ROTATOR',
	ROTATOR_SQTV = 'ROTATOR_SQTV',
	ROTATOR_SPORT = 'ROTATOR_SPORT',
	ROTATOR_WHY_TO_WATCH = 'ROTATOR_WHY_TO_WATCH',
	ROTATOR_EDITORIAL_PICKS = 'ROTATOR_EDITORIAL_PICKS',
}
